export default __webpack_public_path__ + "81c6905060ed5048958611622ea9107c.svg";